export default function newsletterAdvCtrl($scope, $http, $rootScope) {
    $scope.validOptionNewsletter = {
        rules: {
            name: {
                required: true,
            },
            email: {
                required: true,
                email: true
            },
            phone: {
                required: true,
            },
        },
        messages: {
            name: {
                required: "REQUIRED",
            },
            email: {
                required: "REQUIRED",
                email: "THIS IS NOT AN EMAIL"
            },
            phone: {
                required: "REQUIRED",
            },
        },
        ignore: [],
        errorPlacement: function (error, element) {
            error.insertAfter($(element));

        },
        highlight: function (element, errorClass, validClass) {
            $(element)
                .parent()
                .addClass('has-error');
        },
        unhighlight: function (element, errorClass, validClass) {
            if ($(element).is(":hidden")) { }
            $(element)
                .parent()
                .removeClass('has-error')
        }
    };

    $scope.newsletterForm = {};
    $scope.errorMessage = '';
    $scope.newsletter = {
        sending: false,
        sent: false
    };

    $scope.frm = {};

    $scope.openNewsletterModal = function () {
        $.fancybox.open({
            src: '#newsletter',
            type: 'inline',
            opts: {
                clickSlide: false,
                animationEffect: "zoom-in-out",
                animationDuration: 500,
                btnTpl: {
                    smallBtn: `
                    <button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}">
                        <i class="icon-close"></i>
                    </button>
                    `,
                },
                afterClose: function () {
                    // console.log('$scope.newsletterForm:', $scope.newsletterForm)

                    // $scope.frm.gender = "";
                    $scope.frm.name = "";
                    $scope.frm.email = "";
                    $scope.frm.phone = "";

                    $scope.newsletter.sending = false;
                    $scope.newsletter.sent = false;
                }
            },
        });
    };

    $scope.subscribeToNewsletter = function ($event, _action) {
        $event.preventDefault();
        $scope.errorMessage = '';
        if ($scope.newsletterForm.validate()) {
            $scope.newsletter.sending = true;
            var _data = $scope.frm;
            _data._token = window.Laravel.csrfToken;
            // _data = $rootScope.params(_data), // pass in data as strings
            $http({
                method: "POST",
                url: _action,
                data: _data,
            }).then(function (response) {
                var data = response.data;
                $scope.newsletter.sending = false;
                $scope.newsletter.sent = true;
            }, function (response) {
                var data = response.data;
                $scope.errorMessage = data.message;
                $scope.newsletter.sending = false;
            });

            // setTimeout(() => {
            //     $scope.newsletter.sending = false;
            //     $scope.newsletter.sent = true;
            // }, 1000);
        }
    };
}

newsletterAdvCtrl.$inject = ['$scope', '$http'];